import { Link, useLocation } from "react-router-dom";
import IndustriesPopover from "./IndustriesPopover";
import logo from "../../../assets/images/svg/Yantr-ai-website-logo-w.svg";
import hamburger from "../../../assets/images/svg/Menu.svg";

import PlatformPopover from "./PlatformPopover";
import { useEffect, useState } from "react";
type Props = {};

const Navbar: React.FC = (props: Props) => {
  // url
  const route = useLocation();

  const [plateform, setPlateform] = useState(false);
  const [indutry, setIndutry] = useState(false);
  const [currentUrl, setCurrentUrl] = useState("");

  const ShowModal = (type: any) => {
    if (type === "plateform") {
      setPlateform(true);
    } else if (type === "industry") {
      setIndutry(true);
    }
  };
  const HideShowModal = (type: any) => {
    if (plateform) {
      setPlateform(false);
    } else if (type === "industry") {
      setIndutry(false);
    }
  };

  useEffect(() => {
    setMenu(false);
    setCurrentUrl(window.location.pathname);
  }, [route]);
  const [menu, setMenu] = useState<any>(false);
  return (
    <>
      <div
        className="w-100 px-20 navbars d-block d-md-none py-3"
        style={{ backgroundColor: "#000000" }}
      >
        {/* mobile */}
        <div className="row container-fluid">
          <div className="col-11 mt-2">
            <Link to={"/"}>
              <img className="logo-mobile w-18" src={logo} alt="logo" />
            </Link>
          </div>
          <div className="col-1 mt-2">
            <img
              onClick={() => {
                setMenu(!menu);
                setPlateform(false);
                setIndutry(false);
              }}
              src={hamburger}
              alt="hamburger Menu"
            />
          </div>
        </div>

        {menu && (
          <div style={{ backgroundColor: "#2A3751" }}>
            <div className="d-flex justify-content-end px-3 py-2">
              <i
                className="fa-solid fa-x text-white"
                onClick={() => setMenu(!menu)}
              ></i>
            </div>
            <div
              className="dropdown-element px-3 py-1"
              style={{ borderBottom: "1px solid #03AFB4" }}
            >
              <div
                className={`pb-1 ${
                  currentUrl === "/capacity-planning" ||
                  currentUrl === "/strategic-planning" ||
                  currentUrl === "/jeopardy-management" ||
                  currentUrl === "/route-mapping" ||
                  currentUrl === "/scenario-modelling" ||
                  currentUrl === "/operational-planning"
                    ? "current"
                    : ""
                }`}
                onClick={() => {
                  setPlateform(!plateform);
                  setIndutry(false);
                }}
              >
                <div className="text-start nav-link btn font-family-roboto-flex font-16 fonts-400 line-19 text-color-success">
                  Platform
                </div>
                {plateform && (
                  <>
                    <div
                      className="wx-1144 z-index-20 px-30 radius-5 position-absolute popover-right"
                      style={{ top: "50%", right: "1%" }}
                    >
                      {/* <div
                        className="hx-12 w-100 bg-transparent position-absolute overflow-hidden"
                        style={{ top: "-11px" }}
                      ></div> */}
                      <PlatformPopover />
                    </div>
                  </>
                )}
              </div>
            </div>
            <div
              className="dropdown-element px-3 py-2"
              style={{ borderBottom: "1px solid #03AFB4" }}
            >
              <p className="text-white">
                <div
                  className={` pb-1 position-relative ${
                    currentUrl === "/telecom" ||
                    currentUrl === "/healthcare" ||
                    currentUrl === "/energy-utilities" ||
                    currentUrl === "/manufacturing"
                      ? "current"
                      : ""
                  }`}
                  onClick={() => {
                    setIndutry(!indutry);
                    setPlateform(false);
                  }}
                  onMouseOutCapture={() => setIndutry(!indutry)}
                >
                  <div className="d-flex justify-content-between nav-link btn font-family-roboto-flex font-16 fonts-400 line-19 text-color-success">
                    Industries
                    <div className="">
                      {" "}
                      <i className="fa-solid fa-chevron-down collapsed"></i>
                    </div>
                  </div>

                  {indutry && (
                    <div
                      className="wx-181 z-index-20 bg-white radius-5 position-absolute"
                      style={{ top: "30px", right: "0", left: "0" }}
                    >
                      <div
                        className="hx-12 w-100 bg-transparent position-absolute"
                        style={{ top: "-11px" }}
                      ></div>
                      <IndustriesPopover />
                    </div>
                  )}
                </div>
              </p>
            </div>
            <div
              className="dropdown-element px-3 py-2"
              style={{ borderBottom: "1px solid #03AFB4" }}
            >
              <div
                className={` pb-1 ${
                  currentUrl === "/why-yantr-ai" ? "current" : ""
                }`}
              >
                <Link
                  className="text-start nav-link btn font-family-roboto-flex font-16 fonts-400 line-19 text-color-success"
                  to={"/why-yantr-ai"}
                >
                  Why Yantr.ai
                </Link>
              </div>
            </div>
            <div
              className="dropdown-element px-3 py-2"
              style={{ borderBottom: "1px solid #03AFB4" }}
            >
              <div
                className={` pb-1 ${
                  currentUrl === "/contact-us" ? "current" : ""
                }`}
              >
                <Link
                  className="text-start nav-link btn font-family-roboto-flex font-16 fonts-400 line-19 text-color-success"
                  to={"/contact-us"}
                >
                  Contact Us
                </Link>
              </div>
            </div>
          </div>
        )}
      </div>

      {/* <div className="position-absolute top-4 w-100 px-40 navbars d-block  d-md-none">
          <div className="d-inline d-flex justify-content-between flex-gap-25 w-100">
            <div>
              <Link to={"/"}>
                <img className=" logo-mobile" src={logo} alt="logo" />
              </Link>
            </div>
            <div className="d-flex align-items-center nav-flex flex-wrap mobile-text-margin">
              
            </div>
          </div>
        </div> */}

      <div className="position-absolute top-4 w-100 px-40 navbars d-none d-md-block">
        {" "}
        {/* website*/}
        <div className="logo-menu-wrap d-flex justify-content-between flex-gap-25 w-100">
          <div>
            <Link to={"/"}>
              <img className="cursor logo-mobile" src={logo} alt="logo" />
            </Link>
          </div>
          <div className="d-flex align-items-center nav-flex flex-wrap mobile-text-margin">
            <div
              className={`navlinks pb-1 ${
                currentUrl === "/capacity-planning" ||
                currentUrl === "/strategic-planning" ||
                currentUrl === "/jeopardy-management" ||
                currentUrl === "/route-mapping" ||
                currentUrl === "/scenario-modelling" ||
                currentUrl === "/operational-planning"
                  ? "current"
                  : ""
              }`}
              onMouseEnter={() => ShowModal("plateform")}
              onMouseLeave={() => HideShowModal("plateform")}
            >
              <div className="nav-link btn font-family-roboto-flex font-16 fonts-400 line-19 text-color-success">
                Platform
              </div>
              {plateform && (
                <>
                  <div
                    onMouseEnter={() => ShowModal("plateform")}
                    onMouseLeave={() => HideShowModal("plateform")}
                    className="wx-1144 z-index-20 bg-white radius-5 position-absolute popover-right"
                    style={{ top: "100%", right: "5%" }}
                  >
                    <div
                      className="hx-12 w-100 bg-transparent position-absolute"
                      style={{ top: "-11px" }}
                    ></div>
                    <PlatformPopover />
                  </div>
                </>
              )}
            </div>
            <div
              className={`navlinks pb-1 position-relative ${
                currentUrl === "/telecom" ||
                currentUrl === "/healthcare" ||
                currentUrl === "/energy-utilities" ||
                currentUrl === "/manufacturing"
                  ? "current"
                  : ""
              }`}
              onMouseEnter={() => ShowModal("industry")}
              onMouseLeave={() => HideShowModal("industry")}
            >
              <div className="nav-link btn font-family-roboto-flex font-16 fonts-400 line-19 text-color-success">
                Industries
              </div>
              {indutry && (
                <div
                  className="wx-181 z-index-20 bg-white radius-5 position-absolute"
                  style={{ top: "30px", right: "0", left: "0" }}
                >
                  <div
                    className="hx-12 w-100 bg-transparent position-absolute"
                    style={{ top: "-11px" }}
                  ></div>
                  <IndustriesPopover />
                </div>
              )}
            </div>
            <div
              className={`navlinks pb-1 ${
                currentUrl === "/why-yantr-ai" ? "current" : ""
              }`}
            >
              <Link
                className="nav-link btn font-family-roboto-flex font-16 fonts-400 line-19 text-color-success"
                to={"/why-yantr-ai"}
              >
                Why Yantr.ai
              </Link>
            </div>
            {/* <div
              className={`navlinks pb-1 ${
                currentUrl === "/resources" ? "current" : ""
              }`}
            >
              <Link
                className="nav-link btn font-family-roboto-flex font-16 fonts-400 line-19 text-color-success"
                to={"/resources"}
              >
                Resources
              </Link>
            </div> */}
            <div
              className={`navlinks pb-1 ${
                currentUrl === "/contact-us" ? "current" : ""
              }`}
            >
              <Link
                className="nav-link btn font-family-roboto-flex font-16 fonts-400 line-19 text-color-success"
                to={"/contact-us"}
              >
                Contact Us
              </Link>
            </div>
          </div>
        </div>
      </div>
      {/* <Link
        className="position-absolute top-4 hx-35 wx-187 left-25 z-index-1"
        to={"/"}
      >
        <img className="cursor" src={logo} alt="logo" />
      </Link>

      <ul className="nav justify-content-end position-absolute right-0 left-0 top-5">
        <li className="nav-item">
          <OverlayTrigger
            trigger="click"
            placement="bottom"
            overlay={PlatformPopover}
          >
            <button
              className="nav-link btn font-family-roboto-flex font-16 fonts-400 line-19"
              data-container="body"
              data-toggle="popover"
              data-placement="bottom"
              data-bs-toggle="tab"
            >
              Platform
            </button>
          </OverlayTrigger>
        </li>

        <li className="nav-item">
          <OverlayTrigger
            trigger="click"
            placement="bottom"
            overlay={IndustriesPopoever}
          >
            <button className="nav-link btn font-16 fonts-400 line-19 letters-2">
              Industries
            </button>
          </OverlayTrigger>
        </li>

        <li className="nav-item">
          <Link
            className="nav-link btn font-16 fonts-400 line-19 letters-2"
            to={"/why-yartri-ai"}
          >
            Why Yantr.ai
          </Link>
        </li>
        <li className="nav-item">
          <Link
            className="nav-link btn font-16 fonts-400 line-19 letters-2"
            to={"/resources"}
          >
            Resources
          </Link>
        </li>
        <li className="nav-item">
          <Link
            to={"/contact-us"}
            className="nav-link btn font-16 fonts-400 line-19 letters-2"
          >
            Contact Us
          </Link>
        </li>
      </ul> */}
    </>
  );
};

export default Navbar;
